import * as EventEmitter from 'eventemitter3';
import * as WebFont from 'webfontloader';
import { IFont } from '../data/IFont';

interface LoadRequest {
  fonts: IFont[];
  characters?: string;
}
// const isRequestEqualTo = (
//   requestA: LoadRequest,
//   requestB: LoadRequest
// ): boolean => {
//   return JSON.stringify(requestA) === JSON.stringify(requestB);
// };

const createFamiliesFromIFonts = (fonts: IFont[]): string[] => {
  let currentFamily: string | null = null;
  let familyToAdd: string | null = null;
  const families: string[] = [];
  for (const f of fonts) {
    if (f.family !== currentFamily) {
      if (familyToAdd) {
        families.push(familyToAdd);
      }
      currentFamily = f.family;
      const separator = f.family.includes(':') ? ',' : ':';
      familyToAdd = f.family + separator + f.weight;
    } else {
      familyToAdd += ',' + f.weight;
    }
  }
  if (familyToAdd) {
    families.push(familyToAdd);
  }
  return families;
};

class FontLoader extends EventEmitter {
  isLoading = false;
  pendingRequests: LoadRequest[] = [];

  load(request: LoadRequest) {
    this.pendingRequests.push(request);
    if (!this.isLoading) {
      this.loadNext();
    }
  }

  loadNext() {
    if (this.pendingRequests.length) {
      const request = this.pendingRequests.shift()!;
      const families = createFamiliesFromIFonts(request.fonts);
      this.isLoading = true;
      WebFont.load({
        google: {
          families,
          text: request.characters
        },
        active: () => {
          this.loadNext();
          this.emit('loaded', request);
        },
        inactive: () => {
          this.loadNext();
          this.emit('error', request);
        }
      });
    } else {
      this.isLoading = false;
    }
  }
}

const loader = new FontLoader();

const loadFonts = async (
  fonts: IFont[],
  characters?: string
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const myRequest = {
      fonts,
      characters
    };
    loader.on('loaded', (request: LoadRequest) => {
      // console.log('Loaded...');
      // console.log(request);
      if (myRequest === request) {
        resolve();
      }
    });
    loader.on('error', (request: LoadRequest) => {
      // console.log('Error...');
      console.error(request);
      if (myRequest === request) {
        reject();
      }
    });
    loader.load(myRequest);
  });
};

export { loadFonts };



// WEBPACK FOOTER //
// ./src/utils/FontLoader.ts